var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',_vm._b({style:(_vm.computedSpacingStyles),attrs:{"src":_vm.computedSrc,"alt":_vm.computedAlt}},'b-img',{ id: _vm.id, height: _vm.height, width: _vm.width, fluid: _vm.fluid, fluidGrow: _vm.fluidGrow },false))}
var staticRenderFns = []

export { render, staticRenderFns }